import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { HomVersionService } from 'hom-lib/hom-environment';
import { cloneDeep } from 'lodash-es';

import { HomLocalStorage } from '../enums/hom-local-storage.enums';
import { IAuthResult, IHomUser } from '../interfaces';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as fromRoot from '../../app/store/reducers/index';
import { getAuthState } from '../../app/store/reducers/index';
import { IState } from '../store';
import * as AuthActions from '../store/auth.actions';

@Component({
  templateUrl: './refresh-user.component.html',
  standalone: false
})
export class RefreshUserComponent implements OnInit, OnDestroy{
  destroyRef = inject(DestroyRef);

  constructor(
        public activeRoute: ActivatedRoute,
        public rootStore: Store<fromRoot.IState>,
        public versionService: HomVersionService
  ) {}

  ngOnInit(): void {
    this.rootStore.pipe(
      select(getAuthState),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: IState) => {
      const auth: IState = cloneDeep(state);
      if (!auth.authenticated && !auth.refreshing) {
        const storageData = localStorage.getItem(HomLocalStorage.HomUser);
        const homUser: IHomUser = JSON.parse(storageData);
        if (homUser !== null && homUser.expiry > new Date().getTime()) {
          const authResult: IAuthResult = {
            errors: [],
            providerUser: homUser.providerUser,
            returnUrl: '',
            success: true,
            token: homUser.token,
            crmVersion: this.versionService.version() ?? ''
          };
          this.rootStore.dispatch(new AuthActions.SetRefreshing(true));
          this.rootStore.dispatch(new AuthActions.RefreshUserInformation(authResult));
        }
      }
    });
  }

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
